import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Settings } from 'lucide-react'

interface Props { className?: string }

const AdminOpsWidget: React.FC<Props> = ({ className }) => {
  const navigate = useNavigate()
  return (
    <div
      onClick={() => navigate('/dashboard/operations')}
      className={`cursor-pointer rounded-xl border border-[var(--border,#e5e9f0)] bg-[var(--card,#fff)] p-4
        hover:shadow-md hover:border-[var(--teal,#6ec2cf)] transition-all duration-200 flex flex-col items-center gap-2 ${className || ''}`}
    >
      <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#6ec2cf] to-[#275269] flex items-center justify-center">
        <Settings size={20} className="text-white" />
      </div>
      <span className="text-sm font-semibold text-[var(--text,#1C2A3A)]">Operations</span>
      <span className="text-xs text-[var(--muted,#64748b)]">Open</span>
    </div>
  )
}

export default AdminOpsWidget
